import { Combobox } from '@base-ui/react/combobox';
import styles from "./YuJaComboBox.module.css"
import { ReactComponent as ArrowDown } from "../../images/YuJa_arrow_down_icon.svg";
import {ReactComponent as SearchIcon} from "../../images/search_bar_icon.svg";
import React, {useEffect, useState} from "react";
import {Separator} from "@base-ui/react/separator";
import OverflowText from "../OverflowText";

export default function YuJaComboBox({
                                         size = "medium",
                                         options = [],
                                         value,
                                         onChange,
                                         multiple = false,
                                         ariaLabel,
                                         placeholder="",
                                         searchPlaceholder="Search...",
                                         getOptionLabel,
                                         getOptionValue,
                                         style={},
                                         positionStyle={},
                                         unitTerm="item",
                                         ...props
                                     }) {
    const [items, setItems] = useState([]);
    const [isOpened, setIsOpened] = useState(false);

    let triggerSize;
    if (size === "small") {
        triggerSize = styles.small;
    } else if (size === "large") {
        triggerSize = styles.large;
    } else {
        triggerSize = styles.medium;
    }

    let itemSize;
    if (size === "small") {
        itemSize = styles.smallItem;
    } else if (size === "large") {
        itemSize = styles.largeItem;
    } else {
        itemSize = styles.mediumItem;
    }



    useEffect(() => {
        let newItems = options.map(opt => {
            return {...opt, value: getValue(opt), label: getLabel(opt)};
        });
        setItems(newItems);

    }, [options]);

    const getLabel =(item) => {
        if (!item) {
            return "";
        }
        if (getOptionLabel) {
            return getOptionLabel(item);
        }

        return item.label;
    }

    const getValue =(item) => {
        if (!item) {
            return "";
        }
        if (getOptionValue) {
            return getOptionValue(item);
        }

        return item.value;
    }

    function renderValue() {
        if (!value || value.length === 0) {
            return placeholder;
        }

        if (!multiple || !Array.isArray(value)) {
            const option = options.find((opt) => getValue(opt) === value);
            return option ? getLabel(option) : value;
        }


        const labels = value.map((val) => {
            const option = options.find((opt) => getValue(opt) === val);
            return  option ? getLabel(option) : value;
        });

        return `${value.length} ${unitTerm}${value.length > 1 ? "s" : ""} selected`;

        //
        //
        // const option = options.find((opt) => getValue(opt) === value);
        // return option ? getLabel(option) : value;
    }

    return (
        <Combobox.Root
            multiple={multiple}
            items={items}
            value={value}
            onValueChange={((val, eventDetails) => {
                if (eventDetails?.reason !== 'none') {
                    if (multiple) {
                        let opts = options.filter(opt => val.includes(getValue(opt)));
                        onChange(opts);
                    } else {
                        let opt = options.find(opt => getValue(opt) === val);
                        onChange(opt);
                    }


                }
            })}
            onOpenChange={open => setIsOpened(open)}
        >
            <Combobox.Trigger
                className={`${styles.Trigger} ${triggerSize} ${isOpened ? styles.isOpened : ""}`}
                aria-label={ariaLabel}
                style={{...style}}
                {...props}
            >
                <OverflowText>
                    <span style={{textAlign: "start"}}>{renderValue()}</span>
                </OverflowText>

                <Combobox.Icon className={styles.ArrowIcon}>
                    <ArrowDown/>
                </Combobox.Icon>
            </Combobox.Trigger>

            <Combobox.Portal keepMounted={true}>
                <Combobox.Positioner className={styles.Positioner} sideOffset={8} positionMethod={"fixed"} style={{...positionStyle}}>
                    <Combobox.Popup className={styles.Popup}>
                        <div className={styles.InputWrapper}>
                            <SearchIcon aria-hidden={"true"} stlye={{flexShrink: 0}}/>
                            <Combobox.Input placeholder={searchPlaceholder} className={styles.Input} />
                        </div>
                        <Separator orientation={"horizontal"} className={styles.Separator}/>
                        <Combobox.Empty className={`${styles.Item} ${itemSize} ${styles.Empty}`}>No result found.</Combobox.Empty>

                        <Combobox.List className={styles.List}>
                            {(item) => (
                                <Combobox.Item
                                    title={item.label}
                                    key={item.value}
                                    value={item.value}
                                    className={`${styles.Item} ${itemSize}`}
                                >
                                    {multiple &&
                                        <Combobox.ItemIndicator className={styles.ItemIndicator} keepMounted={true}>
                                            <CheckIcon className={`${styles.ItemIndicatorIcon} ${styles.selected}`} />
                                            <UncheckIcon className={`${styles.ItemIndicatorIcon} ${styles.unselected}`} />
                                        </Combobox.ItemIndicator>
                                    }
                                    <div className={styles.ItemText}>{item.label}</div>
                                </Combobox.Item>
                            )}
                        </Combobox.List>
                    </Combobox.Popup>
                </Combobox.Positioner>
            </Combobox.Portal>

        </Combobox.Root>
    );
}

function CheckIcon(props) {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2 0.34668H15C15.9133 0.34668 16.6533 1.08669 16.6533 2V15C16.6533 15.9133 15.9133 16.6533 15 16.6533H2C1.08669 16.6533 0.34668 15.9133 0.34668 15V2C0.34668 1.08669 1.08669 0.34668 2 0.34668Z"
                fill="#0B6F85"/>
            <path
                d="M2 0.34668H15C15.9133 0.34668 16.6533 1.08669 16.6533 2V15C16.6533 15.9133 15.9133 16.6533 15 16.6533H2C1.08669 16.6533 0.34668 15.9133 0.34668 15V2C0.34668 1.08669 1.08669 0.34668 2 0.34668Z"
                stroke="#0B6F85" strokeWidth="0.692616"/>
            <path d="M13.509 4.40869L6.49265 12.1259L2.9845 8.26748" stroke="white" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
}

function UncheckIcon(props) {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.5" y="0.5" width="16" height="16" rx="1.5" fill="white" stroke="#6F6F6F"/>
        </svg>
    );
}